import { motion } from 'framer-motion';

const PageHero = ({ image, children, className = '' }) => {
  return (
    <section className={`relative py-24 lg:py-32 overflow-hidden ${className}`}>
      {image && (
        <div className="absolute inset-0">
          <img
            src={image}
            alt=""
            className="w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B2A57]/95 via-[#0B2A57]/85 to-[#0B2A57]/60" />
        </div>
      )}
      {!image && <div className="absolute inset-0 bg-[#071E45]" />}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
